
import { shipmentLIst } from '../components/KlearviewDashBoardUK/helper';
import { HttpClient } from './httpClient';
import { isEU } from './jobTransitionCalls';
import { isEngineOrIframeMode, isShipmentFromEngine } from '../util/index';
import { isLvsShipmentEngine } from '../CBSA_App/util/index';

export const getKlearViewRecordCount =(payload)=>{
  let eventMessage = {
    "eventType": "GET_BROKER_REPORT_COUNT",
    "eventMessage": payload,
  "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}

export const getQueryVariable = (variable) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
  return null;;
}

export const exelExport =(shipmentLIst , columnNaneList ,queryType, isAllShipmentRequest , kVBShipmentRequest ,excludedIds)=>{
  let data = {
    "eventType": "GENERATE_EXCEL_REPORT",
    "eventTime": Date.now(),
    "eventMessage": {
      isStatementRequest  : [ "STATEMENTS_RECEIVED" ,"STATEMENTS_PENDING" , "STATEMENTS_LATE"].includes(queryType) === true ? "1" : "0",
      "columns": {
        "value":columnNaneList
    },
    isAllShipmentRequest:isAllShipmentRequest
    },

  }

  if(data.eventMessage.isAllShipmentRequest === "0"){
    data.eventMessage.shipmentids={
      value : shipmentLIst
    }
  }


  if(data.eventMessage.isAllShipmentRequest === "1"){
    data.eventMessage.kVBShipmentRequest=kVBShipmentRequest
    data.eventMessage.excludedIds= {
      value : excludedIds
    }
  }

  return HttpClient.custom({
    data: data,
  })
}

export const getcustomer = (filerCode)=> {
  let data = {
    "eventType": "GET_IMPORTER_MAP",
    "eventMessage": {
      "value":  filerCode
    },
  "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: data,
  })
}

export const getKlearViewShipmentsUK = (eventMessage)=> {
  let data = {
    "eventType": "GET_SHIPMENTS_FOR_SELECTION",
    "eventMessage": eventMessage,
  "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: data,
  })
}

export const getKlearViewStatements = (eventMessage)=> {
  let data = {
    "eventType": "GET_STATEMENTS_FOR_SELECTION",
    "eventMessage": eventMessage,
  "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: data,
  })
}


export const getHotShipmentCount = (payloadForCounterApi) => {
  let eventMessage = {
    "eventType": "GET_HOT_SHIPMENTS",
    "eventMessage":{
      "importer": payloadForCounterApi.importerId,
      brokerCode: payloadForCounterApi.filerCode,
      pageStart:payloadForCounterApi.pageStart,
      pageEnd:payloadForCounterApi.pageEnd,
      "modeOfTransports": {
          "value": payloadForCounterApi.mot
      }
    } ,
  "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}


export const getSearchCountData = (country, typeOfUser, filerCode, custFilter="") =>{
  // Not needed for engine iframe or isShipment (engine-opened KX shipment) flows
  if((isEngineOrIframeMode() || isShipmentFromEngine()) && getQueryVariable('shipmentHttpId')){
    return new Promise((resolve, reject) => {
      resolve({
        "data": {
          "eventType": "GET_SEARCH_TAB_COUNT",
          "eventMessage": {
              "recentTabCount": 0,
              "rejectTabCount": 0,
              "holdTabCount": 0,
              "activeTabCount": 0,
              "completeTabCount": 0,
              "alvphTabCount":0,
              "queryTabCount":0,
              "newTabCount":0
          },
          "eventTime": Date.now()
      },
        "status": 200,
        "statusText": "",
        "request": {}
      });
    })
  }

  let eventMessage = {
      "eventType": "GET_SEARCH_TAB_COUNT",
      "eventMessage": {
      "countryCode": country,
      "typeOfUser": typeOfUser,
      "filerCode": filerCode,
      "importer": custFilter || "",
      "isNcts": (window.shipmentMode === 'TRANSIT_SHIPMENTS')
    },
    "eventTime": Date.now()
    }

    // if(window.shipmentMode === 'LVS_SHIPMENTS'){
    //   eventMessage.isLvs = true
    // }

    return HttpClient.custom({
      data: eventMessage,
    })
}



export const getBrokerShipments = (filters, page, searchTab, direction, isLvsShipment, isPartialTextSearchEnabled) => {
  const data = brokerShipmentsBody(filters, page, searchTab, direction, isLvsShipment, isPartialTextSearchEnabled);
  const prefetched = window.__knJobsPrefetch;
  if (
    prefetched &&
    window.__knJobsPrefetchType === data.eventType &&
    !window.__knJobsPrefetchUsed
  ) {
    window.__knJobsPrefetchUsed = true;
    return Promise.resolve(prefetched).then((payload) => {
      if (!payload) {
        window.__knJobsPrefetchUsed = false;
        return HttpClient.custom({ data });
      }
      if (payload && payload.data) return payload;
      return { data: payload };
    }).catch(() => HttpClient.custom({ data }));
  }
  return HttpClient.custom({
    data
  })
}

export const getHotCount = () => {
  let eventMessage = {
    "eventType": "GET_HOT_SHIPMENTS",
    "eventMessage":{
      "importer": "",
      "brokerCode": "",
      "modeOfTransports": {
          "value": []
      }
    } ,
  "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}


const brokerShipmentsBody = (filters, pageNumber, searchTab, direction, isLvsShipment, isPartialTextSearchEnabled) => {
  let oneShipmentFromHTTPParam = getQueryVariable('shipmentHttpId');
  if(isEngineOrIframeMode()){
    if(document.getElementById("root"))document.getElementById("root").classList = " onlyShowOneShipment ";
  }
  if(oneShipmentFromHTTPParam && getQueryVariable('isShipment') == "true"){
    filters=[{"key":"SEARCH_FILTERS_SHIPMENT_ID","value":oneShipmentFromHTTPParam}]
  }

  let eventMessage = {
    pageNumber
  }
  if(window.shipmentMode !== 'TRANSIT_SHIPMENTS'){
    eventMessage.searchType =  "SEARCH_TYPE_BROKER";
  }
  let newFilter = filters.slice();
  if (newFilter && newFilter.length > 0) {
    if(window.shipmentMode === 'LVS_SHIPMENTS'){
      let lvsMonth = newFilter.find((_item)=>{
        return (_item.key === 'SEARCH_FILTERS_LVS_MONTH')
      })
      let lvsYear = newFilter.find((_item)=>{
        return (_item.key === 'SEARCH_FILTERS_LVS_YEAR')
      })
      if(lvsMonth && lvsYear){
        newFilter.push({key: "SEARCH_FILTERS_LVS_MONTH_FROM", value: (lvsYear.value+"-"+lvsMonth.value)})
        newFilter.push({key: "SEARCH_FILTERS_LVS_MONTH_TO", value: (lvsYear.value+"-"+lvsMonth.value)})
      }
      else if(!lvsMonth && lvsYear){
        newFilter.push({key: "SEARCH_FILTERS_LVS_MONTH_FROM", value: (lvsYear.value+"-01")})
        newFilter.push({key: "SEARCH_FILTERS_LVS_MONTH_TO", value : (lvsYear.value+"-12")})
      }
      newFilter = newFilter.filter((_item_)=>{
        return (_item_.key!=="SEARCH_FILTERS_LVS_MONTH" && _item_.key!=="SEARCH_FILTERS_LVS_YEAR" && _item_.key!=="SEARCH_FILTERS_MODE")
      })
    }
  }
  if (getQueryVariable('isShipment') == "true") {
    if (!newFilter.some((f) => f.key === "SEARCH_FILTERS_ENGINE_SHIPMENTS")) {
      newFilter.push({ key: "SEARCH_FILTERS_ENGINE_SHIPMENTS", value: "true" });
    }
  }
  if (newFilter && newFilter.length > 0) {
    eventMessage.filters = newFilter
  }
  if(window.shipmentMode === 'LVS_SHIPMENTS' || isLvsShipmentEngine()){
    eventMessage.isLvs = true
  }

  if(((filters||[]).find(a=>a.key=="SEARCH_FILTERS_KEYWORD" || a.key=="SEARCH_FILTERS_SHIPMENT_ID")?.value||"").length > 3){
    searchTab="SEARCH_TAB_ALL"
  }
  if (searchTab) {
    eventMessage.searchOrder = {
      searchTab,
      direction
    }
  }
  if(!searchTab && direction){
    eventMessage.searchOrder = {
      direction
    }
  }

  
  let eventTypeEngine = `GET_ENTRY_STATUS`

  const editShipment = getQueryVariable('editShipment') == "true";
  const useEngineRequjest = (isEngineOrIframeMode() && oneShipmentFromHTTPParam && !editShipment) ;
  if(useEngineRequjest && !getQueryVariable('isShipment')){

    const transactionCountry = getQueryVariable('transactionCountry')
    eventTypeEngine = isEU(transactionCountry) ? `GET_${transactionCountry}_ENTRY_STATUS`: `GET_ENTRY_STATUS`
    
    const extraParams = isEU(transactionCountry) ? {
      transactionType: getQueryVariable('transactionType'),
      countryCode: transactionCountry,
    } : {}

    eventMessage = {
        "entryIds": [oneShipmentFromHTTPParam],
        ...extraParams
    }

  }

  if(getQueryVariable("shipmentHttpId") && getQueryVariable("shipmentHttpId").startsWith("KX-") && getQueryVariable("docOnlyBroker") == "true"){
    eventMessage = {
      "shipmentId": getQueryVariable("shipmentHttpId")
    }
  }

  let eventType;

  // Engine Transaction (onlyOneShipment, not isShipment) → GET_ENTRY_STATUS.
  // isShipment=true / editShipment stay on SEARCH_SHIPMENTS_BROKER* (CORE-69771).
  if (useEngineRequjest && !isShipmentFromEngine())
    eventType = eventTypeEngine;
  else if (window.shipmentMode === 'TRANSIT_SHIPMENTS')
    eventType = "FETCH_TRANSIT_SHIPMENTS";
  else if (isPartialTextSearchEnabled)
    eventType = "SEARCH_SHIPMENTS_BROKER";
  else
    eventType = "SEARCH_SHIPMENTS_BROKER_FULLTEXT";
  
  return ({
    eventMessage,
    eventType,
    eventTime: Date.now(),
  })
}

const getResponseEvent = () => {
  let eventName = "GET_CBP_RESPONSE_MESSAGE";
  switch (window.shipmentCountry){
    case "CA":
      eventName = "GET_CBSA_RESPONSE_MESSAGE"
      break;
    case "GB":
      eventName = "GET_UK_RESPONSE_MESSAGE"
      break;
    case "US":
      eventName = "GET_CBP_RESPONSE_MESSAGE"
    break; 
    default :
    eventName = "GET_CBP_RESPONSE_MESSAGE"
    break; 
  }
  return eventName;
}

export const getMessages = (id) => {
  let type = (window.shipmentCountry === 'CA')? "DOC_C": "DOC_ENTRY_7501";
  let eventType = getResponseEvent();
  let eventMessage = (window.shipmentCountry === 'GB')? id :  {
    shipmentid: id,
    type: type
  }
  const isEngine = 'kxEngineBrokerToken' == window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN;
  if(window.pscShipmentId && typeof eventMessage === "object" && !isEngine){
    eventMessage.createPSC = 1
  }
  let body = {
    eventMessage:eventMessage,
    eventType: eventType,
    eventTime: Date.now(),
  }
  return HttpClient.custom({
    data: body,
  })
}


export const getLatestResponse = (id, shipmentCountry) => {
  let eventType = '';
  switch(shipmentCountry){
    case 'US':
        eventType = "GET_LATEST_RESPONSE_SUMMARY";
        break;
    case 'CA':
        eventType = "GET_LATEST_CBSA_RESPONSE_SUMMARY";
        break;
    case 'GB':
        eventType = "GET_LATEST_RESPONSE_SUMMARY_UK";
        break;  
    default:
        eventType = "";
        break;     
  }

  let body
  if (shipmentCountry === 'CA') {
    body = {
      eventType: eventType,
      eventTime: Date.now(),
      eventMessage: {
        shipmentid: id,
        shipmentId: id,
        islvs: true
      }
    };
    if (window.shipmentMode === 'LVS_SHIPMENTS' || isLvsShipmentEngine()) {
      body.eventMessage.islvs = true;
    } else {
      body.eventMessage.islvs = false;
    }
  }

  else {
     body = {
      "eventType": eventType,
      "eventTime": Date.now(),
      "eventMessage": { 
        "shipmentid": id ,
        "shipmentId": id,
      }
    }
    const isEngine = 'kxEngineBrokerToken' == window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN;
    if(window.pscShipmentId && !isEngine){
      body.eventMessage.createPSC = 1
    } 
  }
  

  return HttpClient.custom({
    data: body,
  })
};

export const get_LONG_CBP_RESPONSE = (fileName_t)=>{
  return HttpClient.custom({data:{
    "eventMessage": {//long_cbp_response_20220222232306157_AG9V3LMZPKHNKJJXWCZO.txt
      "responseFile": `long_cbp_response_${fileName_t}`
    },
    "eventType": "GET_CBP_RESPONSE_MESSAGE",
    "eventTime": Date.now(),
  }})
}


export const get_KLEARVIEW_SHIPMENT_COUNTS = (brokerUserGuid ,payloadForCounterApi) => {
  let body = {

    // "eventType": "GET_KLEARVIEW_SHIPMENT_COUNTS",
   "eventType": "GET_BROKER_REPORT_COUNT",
    "eventTime": Date.now(),
    "eventMessage": payloadForCounterApi,
   
  }
  return HttpClient.custom({
    data: body,
  })
};

export const get_ALL_FILER_CODES_apx = () => {
  let body = {

    "eventType": "GET_ALL_FILER_CODES",
    "eventTime": Date.now(),
    "eventMessage": "",
   
  }
  return HttpClient.custom({
    data: body,
  })

}


export const get_DUTIES_DETAIL = (brokerUserGuid, month) => {
  let body = {

    "eventType": "GET_DUTIES_DETAIL",
    "eventTime": Date.now(),
    "eventMessage": {
      "brokerUserGuid": brokerUserGuid,
      "month": month,//"JULY"
    },
  }
  return HttpClient.custom({
    data: body,
  })
};


export const getLatestCBSAResponse = (id) => {
  let body = {

    "eventType": "GET_LATEST_CBSA_RESPONSE_SUMMARY",
    "eventTime": Date.now(),
    "eventMessage": { "shipmentid": id }
  }
  return HttpClient.custom({
    data: body,
  })
};

export const getCompanyLogo = (email) => {
  let body = { 
    "eventMessage":{ 
       "customerEmail":
         email
       
    },
    "eventType":"GET_CUSTOMER_LOGOS",
    "eventTime": Date.now()
 }
 
  return HttpClient.custom({
    data: body,
  })
};

export const getDocumentTypes = () => {
  let data = {
    eventMessage: "",
    eventType: "GET_DOCUMENT_TYPES",
    eventTime: Date.now()
 }

  return HttpClient.custom({
    data
  });
};

export const getAllFilerCode = () => {
  let data = {
    eventMessage: "",
    eventType: "GET_ALL_FILER_CODES",
    eventTime: Date.now()
 }

  return HttpClient.custom({
    data
  });
};
export const brokerAlarmsAndNotification = () => {
  let data = {
    eventMessage: "",
    eventType: "BROKER_ALARMS_AND_NOTIFICATION",
    eventTime: Date.now()
 }

  return HttpClient.custom({
    data
  });
};

export const getProductHistory = (commercialDescription , productTag, htsus, countryOfOrigin, manufacturerId) => {
  const data = {
    eventMessage: {
      "customerId": window.shipmentId.split("-")[1],//FIX!?!?!??!
      "filerCode" : "300",
      "country": window.shipmentCountry,
      "productDescription": commercialDescription,
      "productTag": productTag,
      "HTS" : htsus,
      "countryOrigin" : countryOfOrigin,
      "manufacturerId": manufacturerId,
    },
    eventTime: Date.now(),
    eventType: "SEARCH_PRODUCT_LINE_HISTORY",
    responseTopic: "",
  };
  if (getQueryVariable('isShipment') == 'true') {
    data.eventMessage.searchType = 'engine';
  }
  return HttpClient.custom({
    data
  })
};

export const getProductLineHistory = (payload) => {
  // if(countryOfReq == "GB")
  // {
  //   countryOfReq = "UK"
  // }
  const data = {
    eventMessage: payload,
    eventTime: Date.now(),
    eventType: "GET_PRODUCT_LINE_HISTORY",
    responseTopic: "",
  };
  return HttpClient.custom({
    data
  })
};

export const searchProductLineHistory = (filerCode, countryOfReq, pageNumber, searchFilters) => {
  if(countryOfReq == "GB")
  {
    countryOfReq = "UK"
  }
  let searchFiltersCopy = {...searchFilters}
  searchFiltersCopy["filerCode"] = filerCode;
  searchFiltersCopy["country"] = countryOfReq;
  const data = {
    eventMessage: {
      "productLineHistoryRecord": searchFiltersCopy,
      "pageNumber": pageNumber
    },
    eventTime: Date.now(),
    eventType: "SEARCH_PRODUCT_LINE_HISTORY_MODULE",
    responseTopic: "",
  };
  return HttpClient.custom({
    data
  })
};

export const addProductLineHistory = (productDescription,  HTS, productTag, manufacturerName, filerCode) => {
  let countryOfReq = window.shipmentCountry;
  if(window.shipmentCountry == "GB")
  {
    countryOfReq = "UK"
  }
  const data = {
    eventMessage: {
      "productLineHistoryRecord": {
        "customerId": window.shipmentId.split("-")[1],//FIX!?!?!??!
        "productDescription": productDescription,
        "filerCode": filerCode,
        "country": countryOfReq,
        "HTS": HTS,
        "productTag": productTag,
        "originCountry" : countryOfReq,
        "manufacturerName": manufacturerName
      }
    },
    eventTime: 1631689695745,
    eventType: "ADD_PRODUCT_LINE_HISTORY_DETAILS",
    responseTopic: "",
  };
  return HttpClient.custom({
    data
  })
};

export const updateProductLineHistory = (productLineId, filerCode, updatedData) => {
  let countryOfReq = window.shipmentCountry;
  if(window.shipmentCountry == "GB")
  {
    countryOfReq = "UK"
  }
  const data = {
    eventMessage: {
      "productLineHistoryRecord": 
        updatedData
        // "HTS": HTS,
        // "productTag": productTag,
        // "originCountry" : countryOfReq,
        // "manufacturerName": manufacturerName
    },
    eventTime: 1631689695745,
    eventType: "UPDATE_PRODUCT_LINE_HISTORY_DETAILS",
    responseTopic: "",
  };
  return HttpClient.custom({
    data
  })
};

export const deleteProductLineHistory = (productLineId) => {
  let countryOfReq = window.shipmentCountry;
  if(window.shipmentCountry == "GB")
  {
    countryOfReq = "UK"
  }
  const data = {
    eventMessage: {
      "productLineId": productLineId
    },
    eventTime: 1631689695745,
    eventType: "DELETE_PRODUCT_LINE_HISTORY_DETAILS",
    responseTopic: "",
  };
  return HttpClient.custom({
    data
  })
};

export const getCustomerList = (country) => {
 let data = {
    "eventType": "LIST_OF_CUSTOMERS",
    "eventMessage": {
      "sortByEmail": true
    },
   "eventTime": 1639027699340
  }
  if(country){
    data.eventMessage.filter = country;
  }
  return HttpClient.custom({
    data
  })
}

export const getProdHistDetails = (productLineId, customerId, countryOfReq) => {
  if(countryOfReq === "GB")
    countryOfReq = "UK";
  let data = {
    eventMessage: {
      "customerId": customerId,
      "productLineId": productLineId,
      "countryOfRequest": countryOfReq
    },
    eventType: "GET_PRODUCT_LINE_HISTORY_DETAILS",
    eventTime: Date.now(),
    responseTopic: "",
  }
  if (getQueryVariable('isShipment') == 'true') {
    data.eventMessage.searchType = 'engine';
  }
  return HttpClient.custom({
    data
  })
}

export const getInternalPSCReason = payload => {
  let eventMessage = {
    "eventType": "GET_PSC_REASON_FOR_SHIPMENT",
    "eventMessage": payload,
    "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}

export const obsoleteDocs = payload => {
  let eventMessage = {
    "eventType": "SET_DOC_TYPE",
    "eventMessage": payload,
    "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}

export const fetchCarmResponse = payload => {
  let eventMessage = {
      eventMessage: payload,
      eventType: "GET_CARM_TRANSACTION_RESPONSE",
      eventTime: Date.now()
  }
  return HttpClient.custom({
    data: eventMessage,
  })
}

export const submitCadAmend = payload => {
  let eventMessage = {
    eventMessage: payload,
    eventType: "SAVE_AMEND_CAD",
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data: eventMessage
  })
}
export const deleteCadAmend = payload => {
  let eventMessage = {
    eventMessage: payload,
    eventType: "DELETE_AMEND_CAD",
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data: eventMessage
  })
}

export const getAllCarmTransactions = payload => {
  let eventMessage = {
    "eventType": "GET_ALL_TRANSACTION_RESPONSES_CARM",
    "eventMessage": payload,
    "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}

export const refreshLvsShipment = payload => {
  let eventMessage = {
    eventType: "RECALCULATE_LVS",
    eventMessage: payload,
    eventTime: Date.now()
  }
  
  return HttpClient.custom({
    data:eventMessage
  })
}

export const getCarmTransactionsById = payload => {
  let eventMessage = {
    "eventType": "GET_TRANSACTION_RESPONSE_CARM_BY_ID",
    "eventMessage": payload,
    "eventTime": Date.now()
  }

  return HttpClient.custom({
    data: eventMessage,
  })
}

const genBeforePDF = (payload) => {
  const data = {
    eventMessage: {
      shipmentId: `${window.shipmentId}`,
      ...payload
    },
    eventType: "GENERATE_PDF",
    eventTime: Date.now(),
  };
  return HttpClient.custom({
    data,
  });
};

export const jobInfoAPI = {
  getBrokerShipments,
  getMessages,
  get_LONG_CBP_RESPONSE,
  getLatestResponse,
  getLatestCBSAResponse,
  getCompanyLogo,
  getDocumentTypes,
  getAllFilerCode,
  brokerAlarmsAndNotification,
  getProductHistory,
  getProdHistDetails,
  getInternalPSCReason,
  obsoleteDocs,
  getAllCarmTransactions,
  genBeforePDF
}